<section [ngClass]="dynamicClass">
  <div class="">
    <div class="eq-flex eq-flex-col" [ngClass]="rendering.fields?.IsHorizontal?.value ? ' eq-gap-[34px] lg:eq-gap-[64px]' : 'lg:eq-flex-row lg:eq-justify-between lg:eq-gap-x-5'">
      <div class="eq-container eq-flex eq-flex-col eq-gap-[18px] eq-mb-[34px] lg:eq-mb-0 lg:eq-gap-[34px] lg:eq-max-w-[587px]">
        <ng-container *ngIf="rendering.fields?.WantTitleWithH1Tag?.value">
          <h1 *ngIf="rendering.fields?.Title?.value" class="eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue lg:eq-text-heading2">
            {{ rendering.fields?.Title?.value }}
          </h1>
        </ng-container>
        <ng-container *ngIf="!rendering.fields?.WantTitleWithH1Tag?.value">
          <h2 *ngIf="rendering.fields?.Title?.value" class="eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue lg:eq-text-heading2">
            {{ rendering.fields?.Title?.value }}
          </h2>
        </ng-container>
        <div *ngIf="rendering.fields?.Subtitle?.value" class="eq-text-body-m eq-text-black-natural-60 lg:eq-text-body">
          {{ rendering.fields?.Subtitle?.value }}
        </div>
        <ng-container *ngIf="!isMobile">
          <div *ngIf="showMoreBtn && !rendering.fields?.IsHorizontal?.value" class="eq-flex eq-justify-center lg:eq-justify-start">
            <button hybridHref type="button" class="eq-btn eq-btn-secondary" (click)="showMore()">{{rendering.fields?.ButtonLabel?.value}}</button>
          </div>
        </ng-container>
      </div>
      <div #DocumentationModuleSlider *ngIf="isMobile" class="swiper eq-container-left !eq-pb-6">
        <div class="swiper-wrapper">
          <ng-container *ngFor="let card of cards;">
            <div class="swiper-slide !eq-w-[270px] !eq-h-auto">
              <app-card-module [rendering]="card"></app-card-module>
            </div>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="!isMobile">
        <div class="eq-container eq-flex eq-w-full">
          <div class="eq-grid eq-gap-5 eq-w-full" [ngClass]="rendering.fields?.IsHorizontal?.value ? 'eq-cards-grid eq-grid-cols-2 lg:eq-grid-cols-1 xl:eq-grid-cols-2' : 'eq-grid-cols-2'">
            <ng-container *ngFor="let card of cards">
              <app-card-module class="eq-w-[344px] lg:eq-w-[464px] md:eq-mx-auto" [rendering]="card"></app-card-module>
            </ng-container>
          </div>
        </div>
        <div *ngIf="showMoreBtn && rendering.fields?.IsHorizontal?.value" class="eq-container eq-flex eq-justify-center">
          <button type="button" class="eq-btn eq-btn-secondary" (click)="showMore()">{{rendering.fields?.ButtonLabel?.value}}</button>
        </div>
      </ng-container>
    </div>
  </div>
</section>